module.exports = __webpack_public_path__ + "img/block_3_img.1f657bd1.png";